import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/portal` });

portalApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("pressops_portal_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

portalApi.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e.config?.url || "";
    if (e.response?.status === 401 && !url.startsWith("/auth/")) {
      localStorage.removeItem("pressops_portal_token");
      if (!window.location.pathname.startsWith("/portal/login")) window.location.href = "/portal/login";
    }
    return Promise.reject(e);
  }
);

export function usePortalLoad(url) {
  const [data, setData] = useState(null);
  const reload = useCallback(async () => {
    try {
      const { data } = await portalApi.get(url);
      setData(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  }, [url]);
  useEffect(() => { reload(); }, [reload]);
  return [data, reload];
}

export async function uploadChunked(client, base, file, onProgress) {
  const { data: s } = await client.post(`${base}/uploads`, { filename: file.name, size: file.size, content_type: file.type || "application/octet-stream" });
  const total = Math.ceil(file.size / s.chunk_size);
  for (let i = 0; i < total; i += 1) {
    const fd = new FormData();
    fd.append("chunk", file.slice(i * s.chunk_size, (i + 1) * s.chunk_size), `${i}`);
    await client.post(`${base}/uploads/${s.id}/chunks/${i}`, fd);
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  return s.id;
}

export async function downloadWith(client, path, filename, inline = false) {
  try {
    const r = await client.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    if (inline) { window.open(url, "_blank"); return; }
    const a = document.createElement("a");
    a.href = url; a.download = filename; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  } catch (e) {
    toast.error(errMsg(e));
  }
}
